import './styles/home.scss'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Testimonials from './Testimonials';
import { useNavigate } from 'react-router-dom';
import learning from './images/ONLINE-LEARNING.webp';
import media from './images/media.webp';
import Faq from './Faq';
import bio from './images/bio_photo.webp';

export default function Home() {
  const navigate = useNavigate()

  const scrollTo = () => {
    document.getElementById("event").scrollIntoView();
  };

  return (
    <main className="home__main">
      <section className="hero">
        <h1>Your Step-by-Step Guide to Property Success in 2025 – No Experience Needed!</h1>
        <img src={media} alt="media image" />
        <p>The Property Investment for Beginners Online Course is your
          all-in-one guide to kickstarting your journey toward financial
          freedom. Wether you have zero experience, limited funds, or
          simply no idea where to begin, this course was designed for
          YOU.</p>
        <button className='cta--btn' onClick={scrollTo}>Get Instant Access Now</button>
        {/* VIDEO WILL GO HERE INSTEAD OF IMAGE */}
      </section>
      <section className='bullet__section'>
        <h2>What You’ll Get with the Property Investment for Beginners Course:</h2>
        <section className="bullet__cols--hold">
          <section className="bullet__cols">
            <article className='bullet__row'>
              <CheckCircleIcon className='bullet--icon' />
              <p><span>Your Investment Plan: </span>Create a personalised strategy tailored to your goals and resources.</p>
            </article>
            <article className='bullet__row'>
              <CheckCircleIcon className='bullet--icon' />
              <p><span>Learn the Basics: </span>Discover simple strategies to start investing, even with little or no money.</p>
            </article>
            <article className='bullet__row'>
              <CheckCircleIcon className='bullet--icon' />
              <p><span>Property Investment Strategies: </span> Explore proven short-term and long-term strategies.</p>
            </article>
            <article className='bullet__row'>
              <CheckCircleIcon className='bullet--icon' />
              <p><span>Build Your Portfolio with the BRRR Strategy: </span> Learn the Buy, Refurbish, Refinance, Repeat
                Strategy to grow your property portfolio.</p>
            </article>
            <article className='bullet__row'>
              <CheckCircleIcon className='bullet--icon' />
              <p><span>Market Cycles and Trends: </span>Learn how to time the market and invest with confidence.</p>
            </article>
          </section>
          <section className="bullet__cols">
            <article className='bullet__row'>
              <CheckCircleIcon className='bullet--icon' />
              <p><span>Avoid Costly Mistakes: </span>Manage risks, overcome common challenges, and make smarter
                decisions.</p>
            </article>
            <article className='bullet__row'>
              <CheckCircleIcon className='bullet--icon' />
              <p><span>Building Your Power Team: </span>Assemble the right experts to support and simplify your journey.</p>
            </article>
            <article className='bullet__row'>
              <CheckCircleIcon className='bullet--icon' />
              <p><span>Where to Find Property Deals: </span>Find profitable property opportunities in your area.</p>
            </article>
            <article className='bullet__row'>
              <CheckCircleIcon className='bullet--icon' />
              <p><span>Understand Financing: </span>Explore creative ways to fund your deals and make them happen.</p>
            </article>
            <article className='bullet__row'>
              <CheckCircleIcon className='bullet--icon' />
              <p><span>Your Action Plan: </span>Develop a a 12-month plan to grow your property portfolio with confidence.</p>
            </article>
          </section>
        </section>
        <h3>Plus, Exclusive Bonuses:</h3>
        <article className='bullet__row'>
          <CheckCircleIcon className='bullet--icon' />
          <p>A free copy of the #1 best-seller <strong>Your Property Jumpstart.</strong></p>
        </article>
        <article className='bullet__row'>
          <CheckCircleIcon className='bullet--icon' />
          <p>Access to the <strong>Deal Calculator</strong> and other essential tools to help you succeed</p>
        </article>
        <h6>By the end of the online course, you’ll have everything you need to confidently take your first steps
          in property investment!</h6>
        <button className='cta--btn' onClick={scrollTo}>Get Instant Access Now</button>
      </section>
      <section className='why__sect'>
        <article className="img__row">
          <aside className="text__side__row">
            <h2>Why Do Most Beginners Struggle</h2>
            <p>Getting started in property investment isn’t easy. The overwhelming amount of advice online often
              leads to confusion. Where do you begin? What strategies actually work? How do you find the
              money to fund deals?</p>
            <p>You’ve probably Googled, watched videos, and downloaded free guides, but none of it seems to
              stick or give you the confidence to take action.</p>
            <p>The truth is, most beginners struggle because they lack a proven, actionable plan and expert
              guidance to help them succeed.</p>
          </aside>
          <img src={learning} alt="online learning with Paul McFadden" />
        </article>
        <article className="img__row">
          <img src={media} alt="online learning with Paul McFadden" />
          <aside className="text__side__row">
            <h2>Think Property Investment Isn’t for You? <span>Think Again</span></h2>
            <p>Maybe you’re worried you don’t have the time, money, or experience to get started.</p>
            <p>But here’s the truth: you don’t need to be rich, have years of experience, or spend hours every day
              to succeed in property investment. <strong>The Property Investment for Beginners</strong> online course is
              designed specifically for people like you—those who want to learn the basics, take action, and see
              real results without feeling overwhelmed.</p>
            <p>By breaking everything down into simple, manageable steps, this course makes property investment
              accessible to anyone, no matter where you’re starting from.</p>
            <p>So, if you’ve ever thought property investment wasn’t for you, think again. With the right plan,
              knowledge, and guidance, you can confidently take your first step toward building a better financial
              future.</p>
          </aside>
        </article>
      </section>
      {/* <section className='why__sect' style={{ backgroundColor: "#fff" }}>
        <h2>Don’t Just Take My Word For It. <br />Here From Our Clients:</h2>
        <Testimonials />
      </section> */}
      <section className="event" id="event">
        <h2>You’re One Decision Away from Starting Your Property Journey</h2>
        <aside className="payment--box">
          <h4>Get Instant Access</h4>
          <h3>Now For...</h3>
          <h2 className="blur"> ONLY £47</h2>
          <button onClick={() => navigate("/register")}>Buy Now </button>
        </aside>
      </section>
      <section className="bio">
        <section className="bio__cols">
          <article className='text__col'>
            <h2>Meet Your Host – Paul McFadden</h2>
            <p>Hi, I’m Paul McFadden, and just like you, I started with no experience, limited resources, and big
              dreams of financial freedom. Fast forward to today, and I’ve built a property portfolio valued at
              over £22 million and helped over 1,000 students achieve their first property deals and passive
              income goals.</p>
            <p>I know how overwhelming it can feel to start in property investment, not knowing where to begin
              or how to make it work for you. That’s why I created the <strong>Online Property Investment for Beginners</strong>
              Course: to break everything into simple steps, remove confusion, and fast-track your success.</p>
            <p>This course is designed with beginners in mind, offering 20 easy-to-follow modules that guide you
              step-by-step toward confidently taking your first step into property investment and achieving
              financial freedom.</p>
            <h4>Why Learn From Me?</h4>
            <article className='bullet__row'>
              <CheckCircleIcon className='bullet--icon' />
              <p>I run the largest property education company in Scotland and one of the biggest in the UK,
                helping thousands of aspiring investors achieve their goals.</p>
            </article>
            <article className='bullet__row'>
              <CheckCircleIcon className='bullet--icon' />
              <p>I’ve helped over 1,000 students secure their first property deals and build lasting wealth.</p>
            </article>
            <article className='bullet__row'>
              <CheckCircleIcon className='bullet--icon' />
              <p>I’ve built a personal property portfolio valued at over £22 million, achieving financial
                freedom by 24 and becoming a millionaire by 26.</p>
            </article>
            <article className='bullet__row'>
              <CheckCircleIcon className='bullet--icon' />
              <p>I’m an active property investor and developer with over 20 years of experience in the
                market.</p>
            </article>
            <article className='bullet__row'>
              <CheckCircleIcon className='bullet--icon' />
              <p>I’m an honorary member of Robert Kiyosaki’s Wealth Master Panel and a recognised expert
                in wealth creation.</p>
            </article>
            <p className="bottom__text">My goal is simple: to empower people like you to break free from financial limitations and build a
              life of independence and success through property investment.</p>

          </article>
          <article className='img__col'>
            <img src={bio} alt="Paul with his Lamborghinni" />
          </article>
        </section>
        <button className='cta--btn' onClick={scrollTo}>Get Instant Access Now </button>
      </section>
      <Faq />

    </main>
  )
}